/* eslint-disable */
import React, { Component } from 'react'

import { View, Text, TouchableOpacity, Image } from 'react-native'
import styles from './Styles/FollowComponentStyle'
import { ButtonGroup, ListItem } from "react-native-elements"
import { getAvatar } from '../Lib/utils'
import SectionHeaderFollow from './SectionHeaderFollow';
import Spacer from './Spacer';
import ImageComponent from './ImageComponent'
import TextComponent from './TextComponent'
import { Fonts } from '../Themes'
//import FastImage from 'react-native-fast-image'
import I18n from "i18n-js"

export default class FollowComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSending: false
    };
  }
  checkSubTile = (subTitle) => {
    if (subTitle && subTitle != '' && subTitle != null && subTitle.length > 0) {

      return <TextComponent style={styles.subTitle} text={subTitle} />
    }
    return
  }
  onSendDirect= (data)=>{
    this.setState({
      isSending : !this.state.isSending
    })
    if( this.props.onPressRightIcon  )
    this.props.onPressRightIcon(data)
  }
  render() {

    const { userId = '', title,
      onAvatarPress,
      userIsFollowing,
      onPressRightIcon, subTitle,
      data,
      onImagePress,
      isSpacer,
      followBtnEnabled = true,
    } = this.props


    return (
      <View style={[styles.container, isSpacer && styles.bottomBorder]} >
        <View style={styles.left}>
          <TouchableOpacity onPress={() => onAvatarPress && onAvatarPress(data)} style={styles.shadow}>
            <Image source={{ uri: getAvatar(userId), cache: 'force-cache' }} style={[styles.avatar]} />
          </TouchableOpacity>
          <View style={styles.leftText}>
            <TextComponent onPress={() => onAvatarPress && onAvatarPress(data)} style={styles.title} text={title} />
            {this.checkSubTile(subTitle)}

          </View>
        </View>
        {followBtnEnabled &&
          <TouchableOpacity style={styles.right} onPress={onPressRightIcon}>
            <SectionHeaderFollow
                style={[styles.buttonText, { color: userIsFollowing == false ? '#FFFFFF' : Fonts.style.color.baseColor }]}
                styleInnstyleButtonerButton = {styles.styleInnerButton}
                containerStyle={[styles.button, { backgroundColor: userIsFollowing == false ? Fonts.style.color.baseColor : '#FFFFFF' }]}
                text={userIsFollowing ? I18n.t('explora.following') : I18n.t('explora.follow')}
                onPress={onPressRightIcon} />
          </TouchableOpacity>}
      </View>

    )
  }
}
